(function($) {

	// Touch vs No-Touch
	if(Modernizr.touch) {
		$('body').addClass('touch');
	} else {
		$('body').addClass('no-touch');
	}
	
	// Lang Nav
	$('a.lang-btn').click(function(e) {
		var winW = $(window).width();
		if(winW > 1221) {
			$(this).toggle();
			$('.lang-nav').toggle();
		} else {
			$('.site-navigation').hide();
			$('html, body').removeClass('navopen');
			$('.lang-nav').toggle();
		}
		e.preventDefault();
	});
	$(window).resize(function() {
		var winW = $(window).width();
		if(winW > 1221) {
			$('.lang-nav').hide();
			$('a.lang-btn').show();
		}
	});
	
	// Mobile Nav
	$('a.nav-btn').click(function(e) {
		$('.lang-nav').hide();
		$('.site-navigation').toggle();
		$('html, body').toggleClass('navopen');
		e.preventDefault();
	});
	$('.foundation-menu-item > a, .memoria-2016-btn > a, .bs-art-menu-item > a').click(function(e) {
		var winW = $(window).width();
		if(winW <= 1222) {
			$(this).parent().toggleClass('down');
			$(this).next('ul.sub-menu').toggle();
			e.preventDefault();	
		}
	});
	
	// Fixed Page Intro */
	$(window).scroll(function() {
		var scrollTop = $(window).scrollTop();
		var introHeight = $('.page-header').outerHeight();
		var winHeight = $(window).height();
		if((scrollTop + winHeight) > introHeight) {
			$('.no-touch .page-header').addClass('fixed');
			$('.no-touch .page-content').addClass('absolute').css('top', introHeight + 'px');
		} else {
			$('.no-touch .page-header').removeClass('fixed');
			$('.no-touch .page-content').removeClass('absolute').css('top', '0');
		}
	});
	
	// Copyright Fundació
	$('.copyright span').click(function(e) {
		$(this).hide();
		$(this).parent().find('.caption').show();
		e.preventDefault();
	});
	
})(jQuery);